import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["handleSubmit", "initialValues", "children", "validationSchema", "validate", "validateOnChange", "validateOnBlur", "bindFormikSubmit"];
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { Formik, Form as FormWrapper, Field } from 'formik';
import { buildSchema } from '../../../utils/formValidationSchema';
import FieldInput from './FieldInput';
import FieldTextArea from './FieldTextArea';
import FieldSelect from './FieldSelect';
import FieldDate from './FieldDate';
import FieldCheckbox from './FieldCheckbox';
var Form = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Form, _React$PureComponent);
  var _super = _createSuper(Form);
  function Form() {
    _classCallCheck(this, Form);
    return _super.apply(this, arguments);
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        initialValues = _this$props.initialValues,
        children = _this$props.children,
        validationSchema = _this$props.validationSchema,
        validate = _this$props.validate,
        validateOnChange = _this$props.validateOnChange,
        validateOnBlur = _this$props.validateOnBlur,
        bindFormikSubmit = _this$props.bindFormikSubmit,
        others = _objectWithoutProperties(_this$props, _excluded);
      return __jsx(Formik, {
        className: "nva-form",
        ref: function ref(node) {
          return _this.form = node;
        },
        initialValues: initialValues,
        validationSchema: buildSchema(validationSchema),
        validate: validate,
        onSubmit: handleSubmit,
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur
      }, function (_ref) {
        var submitForm = _ref.submitForm;
        if (typeof bindFormikSubmit === 'function') {
          bindFormikSubmit(submitForm);
        }
        return __jsx(FormWrapper, _extends({
          noValidate: true
        }, others), children);
      });
    }
  }]);
  return Form;
}(React.PureComponent);
_defineProperty(Form, "defaultProps", {
  className: '',
  initialValues: null,
  validationSchema: null,
  validateOnChange: true,
  validateOnBlur: true
});
_defineProperty(Form, "Input", FieldInput);
_defineProperty(Form, "Field", Field);
_defineProperty(Form, "Select", FieldSelect);
_defineProperty(Form, "TextArea", FieldTextArea);
_defineProperty(Form, "Date", FieldDate);
_defineProperty(Form, "Checkbox", FieldCheckbox);
export default Form;